module.exports = __webpack_public_path__ + "img/emoij.8dee2468.svg";